import { ModalClose, ModalFooterStyled, ModalHeader } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ModalHeaderStyled = styled(ModalHeader)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    border-bottom: 1px solid ${theme.colors.grey[100]};
    padding-top: ${theme.spacings[600]};
    padding-bottom: ${theme.spacings[550]};
    display: 'block';
    & > h1 {
      font-size: ${theme.fontSizes[500]};
    }
  `};
`;
export const ModalFooterSecondaryStyled = styled(ModalFooterStyled)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    padding: ${theme.spacings[400]};
    box-shadow: ${theme.componentStyles.boxShadowInverted};
  `};
`;
export const ModalCloseStyled = styled(ModalClose)`
  ${({ theme }) => css`
    color: ${theme.colors.primary[700]};
  `};
`;
export const ModalContainerStyled = { width: '552px' };
